import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import { useCustomerAuth } from '../services/CustomerAuthContext';

function Header() {
  const { vendor, logout } = useAuth();
  const { customer, logoutCustomer } = useCustomerAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-brand">
        <span className="logo-icon">🏔️</span>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <h1>Timber Summit <span className="brand-expo">Expo</span></h1>
        </Link>
      </div>
      <nav className="header-nav">
        <a href="/#showcase">Showcase</a>
        <a href="/artisans">Vendors</a>
        <a href="/workshop/blueprints">Workshop</a>
        <a href="/commission-board">Commissions</a>
        <a href="/#subscribe">Subscribe</a>
      </nav>
      <div className="header-auth">
        {vendor ? (
          <>
            <Link to="/vendor/dashboard" className="btn-secondary">Dashboard</Link>
            <button className="btn-primary" onClick={logout}>Sign Out</button>
          </>
        ) : customer ? (
          <>
            <Link to="/commissions" className="btn-secondary">Dashboard</Link>
            <button className="btn-primary" onClick={logoutCustomer}>Sign Out</button>
          </>
        ) : (
          <>
            <Link to="/customer/login"><button className="btn-customer-signin">Customer Login</button></Link>
            <Link to="/vendor/login"><button className="btn-vendor-signin">Vendor Login</button></Link>
          </>
        )}
      </div>
      <button className="mobile-menu-btn" onClick={() => setMobileOpen(!mobileOpen)}>☰</button>
      {mobileOpen && (
        <div className="mobile-menu" onClick={() => setMobileOpen(false)}>
          <a href="/#showcase">Showcase</a>
          <a href="/artisans">Vendors</a>
          <a href="/workshop/blueprints">Workshop</a>
          <a href="/#subscribe">Subscribe</a>
          <hr />
          {vendor ? (
            <>
              <Link to="/vendor/dashboard">Dashboard</Link>
              <button onClick={logout}>Sign Out</button>
            </>
          ) : customer ? (
            <>
              <Link to="/commissions">My Commissions</Link>
              <button onClick={logoutCustomer}>Sign Out</button>
            </>
          ) : (
            <>
              <Link to="/customer/login">Customer Login</Link>
              <Link to="/vendor/login">Vendor Login</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}

export default Header;
